import {Messages} from "enterprise-components/src/webmail/Messages";
import {PortalApp} from 'portal/src/PortalApp'
import ReactDOM from 'react-dom/client'
import 'components/src/lang/i18n.js';
import {Route} from "react-router-dom";
import {EnterprisePortalSidebar} from "./EnterprisePortalSidebar";
import 'components/src/fonts/Manrope-VariableFont_wght.ttf'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <PortalApp Sidebar={EnterprisePortalSidebar}>
        <Route path={"messages"} element={
            <Messages/>
        } />
    </PortalApp>
)
